import { api } from '../api'
import { prepareQueryParams } from '@homeviews/utils'
import type { MetaResponse } from '@homeviews/models'

interface IFaqResponse {
  data: any
  meta: MetaResponse
}

export const faqsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getFaqs: builder.query<IFaqResponse, void>({
      query: (params) => {
        return {
          url: `/faqs${prepareQueryParams(params)}`,
        }
      },
    }),
    getFaqsTags: builder.query<any, void>({
      query: () => {
        return {
          url: `/faqs/tags`,
        }
      },
    }),
  }),
})

export const { useGetFaqsQuery, useGetFaqsTagsQuery } = faqsApi
